const TitleDivider = ({ brand, rtl }) => (
  <div
    style={{
      height: 2,
      width: 100,
      marginLeft: rtl ? "auto" : "",
      marginBottom: "10px",
    }}
    className={brand === "Lexus" ? "bg-blue" : "bg-red"}
  />
);

export default TitleDivider;
